import { showDialogWithData, showToast } from "../guest-slices/other.slice"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { BASEURI, headers } from "../../utils/helper"
import { CHECK_EMAIL } from "../../utils/keywords"
import router from "../../routes/routes"
import { Cookies } from "react-cookie"
import axios from "axios"

const cookies = new Cookies()

// Handle user registration
export const userRegistrationReq = createAsyncThunk("userRegistrationReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/register`, data)

    if (response.data?.success) {
      dispatch(showToast({
        type: "success",
        message: response.data?.message
      }))
      return response.data?.user
    } else {
      dispatch(showDialogWithData({
        type: CHECK_EMAIL,
        data: { email: response?.data?.email }
      }))
      const newErr = response.data?.error || "Something went wrong here!"
      if (newErr.toLowerCase().includes("verify your email")) {
        dispatch(showToast({ type: "success", message: "Registration successful. Please verify your email." }))
      } else {
        dispatch(showToast({ type: "error", message: newErr }))
      }
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(showToast({ type: "error", message: newErr }))
    return rejectWithValue(error)
  }
})

// Handle check username
export const checkUsernameReq = createAsyncThunk("checkUsernameReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/check-username`, data)

    if (response.data?.success) {
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

// Handle resent verification email
export const resendVerificationEmailReq = createAsyncThunk("checkUsernameReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/resend-email-verification`, data)

    if (response.data?.success) {
      dispatch(showToast({
        type: "success",
        message: response.data?.message
      }))
      return response.data
    } else {
      dispatch(showDialogWithData({
        type: CHECK_EMAIL,
        data: { email: response?.data?.email }
      }))
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(showToast({ type: "error", message: newErr }))
    return rejectWithValue(error)
  }
})

// Handle update profile
export const updatePasswordReq = createAsyncThunk("updatePasswordReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/update-password`, data, {
      headers: headers()
    })

    if (response.data?.success) {
      dispatch(showToast({
        type: "success",
        message: response.data?.message
      }))
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(showToast({ type: "error", message: newErr }))
    return rejectWithValue(error)
  }
})

// Handle forgot password
export const forgotPasswordReq = createAsyncThunk("userLoginReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/forgot-password`, data)

    if (response.data?.success) {
      dispatch(showToast({
        type: "success",
        message: response.data?.message
      }))
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong here!"
    dispatch(showToast({ type: "error", message: newErr }))
    return rejectWithValue(error)
  }
})

// Handle forgot password
export const resetPasswordReq = createAsyncThunk("userLoginReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/reset-password`, data)

    if (response.data?.success) {
      dispatch(showToast({
        type: "success",
        message: response.data?.message
      }))
      router.navigate("/login")
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong here!"
    dispatch(showToast({ type: "error", message: newErr }))
  }
})

const initialState = {
  user: {},
  other: {},
  
}
const auth = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {

    // Handle registration login
    builder.addCase(userRegistrationReq?.pending, (state) => {
      state.other.loadingSignup = true
    })
    builder.addCase(userRegistrationReq?.fulfilled, (state) => {
      delete state?.other?.loadingSignup
    })
    builder.addCase(userRegistrationReq?.rejected, (state) => {
      delete state?.other?.loadingSignup
    })

    // Handle check username
    builder.addCase(checkUsernameReq?.pending, (state) => {
      state.other.loadingUsername = true
    })
    builder.addCase(checkUsernameReq?.fulfilled, (state) => {
      delete state?.other?.loadingUsername
    })
    builder.addCase(checkUsernameReq?.rejected, (state) => {
      delete state?.other?.loadingUsername
    })

    // Logout
    builder.addCase("Logout", () => {
      cookies.remove("token", { path: "/" })
      router.navigate("/login")
      return initialState
    })
  }
})

export default auth.reducer